export default "__VITE_ASSET__CK7GZ2no__"